import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 9,
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    width: (useStylesParams) =>
      useStylesParams.undock?.treeOfKnowledge ? '100%' : 550,
    minWidth: (useStylesParams) =>
      useStylesParams.undock?.treeOfKnowledge ? '100%' : 550,
    marginLeft: (useStylesParams) =>
      useStylesParams.undock?.treeOfKnowledge ? 0 : 15,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  search: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 15,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
  },
  menuBar: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    padding: 15,
    cursor: 'pointer',
    marginTop: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  right: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.background.paper2,
    zIndex: 9,
    display: 'flex',
    flexDirection: 'column',
  },
  rightHeader: {
    padding: 15,
  },
  content: {
    overflowY: 'auto',
    zIndex: 9,
    padding: 15,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  buttons: {
    padding: 15,
    display: 'flex',
  },
  button: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 15,
    paddingBottom: 10,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.primary.main}`,
    transition: 'all 200ms ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.divider,
    },
    '& > * ': {
      color: theme.palette.primary.main,
    },
  },
  buttonActive: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 15,
    paddingBottom: 10,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.main,
    '& > * ': {
      color: '#fff',
    },
  },
  buttonIcon: {
    fontSize: 20,
    marginBottom: 0,
  },
  info: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: 15,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.hover2}`,
    marginBottom: 15,
  },
  add: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 15,
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.palette.hover2}`,
    backgroundColor: theme.palette.hover,
    '& > * ': {
      color: theme.palette.primary.main,
    },
    transition: 'all 200ms ease-in-out',
    '&:hover': {
      border: `1px dashed ${theme.palette.hover2}`,
      backgroundColor: theme.palette.hover2,
    },
  },
  shortcutContent: {
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'space-between',
    padding: 15,
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    '& > * ': {
      flexGrow: 0,
      overflowWrap: 'anywhere',
      whiteSpace: 'pre-wrap',
    },
    '& h6 ': {
      fontSize: theme.typography.fontSize,
      marginBottom: 5,
    },
  },
  faqContent: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 15,
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    '& h6 ': {
      fontSize: theme.typography.fontSize,
      marginBottom: 5,
    },
  },
  fieldContent: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  contentIcons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    '& * ': {
      color: theme.palette.primary.main,
    },
  },
  emptySpace: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  accordionParent: {
    backgroundColor: theme.palette.background.paper,
    '&> div': {
      padding: '0em !important',
    },
  },
  accordionChild: {
    marginTop: '0.25em',
  },
  accordionChildren: {
    '&> div': {
      justifyContent: 'space-between',
      '&> span': {
        transform: 'rotate(270deg) !important',
      },
    },
  },
  iconContainer: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      opacity: '0.7 !important',
    },
  },
  faqContainer: {
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.3s ease',
    marginBottom: theme.spacing(2),
    border: `2px solid transparent`,
    '&:hover': {
      borderColor: theme.palette.hover2,
    },
  },
  accordion: {
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.3s ease',
    border: `2px solid transparent`,
    margin: theme.spacing(2, 0),
  },
  descriptionContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    cursor: 'auto',
    padding: '1.25em',
    wordBreak: 'break-all',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(1, 0),
  },
  pill: {
    padding: theme.spacing(0.5, 0.75),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.hover2,
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: theme.typography.fontSize,
    wordBreak: 'normal',
    height: 'fit-content',
    whiteSpace: 'nowrap',
  },
  faqTitle: {
    display: 'box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 1,
    boxOrient: 'vertical',
    wordBreak: 'break-all',
    maxHeight: 'fit-content',
    color: theme.palette.primary.main,
  },
  descriptionText: {
    display: 'box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 5,
    boxOrient: 'vertical',
    wordBreak: 'break-all',
    maxHeight: 'fit-content',
  },
  cursorIcon: {
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  hoverContainerChildAccordion: {
    '&:hover': {
      boxShadow: '0 1px 1px 0 rgba(0,0,0,.1), 0 3px 4px 0 rgba(0,0,0,.1)',
    },
  },
  descriptionScriptText: {
    marginRight: '1em',
    marginLeft: '1em',
    color: 'white',
    fontWeight: '400',
    lineHeight: '1.55',
    letterSpacing: '0.07rem !important',
  },
  descriptionFatherContainer: {
    backgroundColor: '#0f1a2d',
    borderRadius: '1em',
    marginTop: '1em',
  },
  scriptDivider: {
    opacity: 0.5,
    border: 'none',
    height: '2px',
    margin: 0,
    marginRight: '0px',
    marginLeft: '0px',
    flexShrink: 0,
    backgroundColor: 'rgba(0,158,226,.1)',
  },
}))

export default useStyles
